// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_gn","advertDetailParameterList__header":"c-q_go","advertDetailParameterList__list":"c-q_gp"};